import React, { useContext, useEffect, useState, useRef, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './Navbar.css';
import { UserContext } from '../UserContext';
import { useBranding } from '../BrandingContext';
import axios from 'axios';
import RegisterPicker from './RegisterPicker';
import { clearRegisterSession } from '../utils/registerSession';
import {
AppBar,
Toolbar,
Typography,
IconButton,
Menu,
MenuItem,
Button,
Tabs,
Tab,
Box,
Avatar,
Dialog,
DialogTitle,
DialogContent,
DialogActions,
TextField,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { alpha } from '@mui/material/styles';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';
function Navbar() {
const { user, setUser } = useContext(UserContext) ;
const { branding, isBranded, brand } = useBranding();
const navigate = useNavigate()                    ;
const location = useLocation()                    ;
const [databaseName, setDatabaseName] = useState('');
const [role, setRole] = useState('');
const [anchorEl, setAnchorEl] = useState(null)    ;
const [selectedTab, setSelectedTab] = useState(0) ;
const [profileMenuEl, setProfileMenuEl] = useState(null) ;
const fileInputRef = useRef(null) ;
const [openResetDialog, setOpenResetDialog] = useState(false)     ;
const [oldPassword, setOldPassword] = useState('');
const [newPassword, setNewPassword] = useState('');
const [confirmNewPassword, setConfirmNewPassword] = useState('');
const [passwordError, setPasswordError] = useState('');
const [openCertificateDialog, setOpenCertificateDialog] = useState(false) ;
const [certificateNumber, setCertificateNumber] = useState('');
const [certificateIssueDate, setCertificateIssueDate] = useState('');
const [certificateExpiryDate, setCertificateExpiryDate] = useState('');
const [certError, setCertError] = useState('');
const [openRegisterDialog, setOpenRegisterDialog] = useState(false);
const [isLoggingOut, setIsLoggingOut] = useState(false);
const logoutTimerRef = useRef(null);
useEffect(() => {
setAnchorEl(null)      ;
setProfileMenuEl(null) ;
}, [location])         ;
const finishLogout = useCallback(() => {
clearRegisterSession();
setUser(null)        ;
setDatabaseName('');
setRole('');
navigate('/login');
}, [navigate, setUser]);
const handleLogout = useCallback((options = {}) => {
if (isLoggingOut) return;
const shouldAnimate = options.animate !== false;
setAnchorEl(null);
setProfileMenuEl(null);
if (!shouldAnimate) {
finishLogout();
return;
}
setIsLoggingOut(true);
logoutTimerRef.current = setTimeout(() => {
finishLogout();
}, 900);
}, [finishLogout, isLoggingOut]) ;
useEffect(() => () => {
if (logoutTimerRef.current) {
clearTimeout(logoutTimerRef.current);
}
}, [])                         ;
useEffect(() => {
let active = true;
const fetchUserDetails = async () => {
const token = localStorage.getItem('token');
if (!token) {
setUser(null)                                ;
const allowedPaths = ['/login', '/register', '/forgot-password', '/reset-password'];
if (!allowedPaths.includes(location.pathname)) {
navigate('/login');
}
return                                                                     ;
}
try {
const response = await axios.get(
`${process.env.REACT_APP_API_BASE_URL}/api/auth/me`,
{
headers: { Authorization: `Bearer ${token}` },
withCredentials: true,
}
)                                                    ;
if (!active || localStorage.getItem('token') !== token) return;
if (response.data.database_name) {
setDatabaseName(response.data.database_name)          ;
setRole(response.data.role)                           ;
setUser(response.data)                                ;
} else {
console.warn('Database name not found for the user');
}
} catch (err) {
if (!active || localStorage.getItem('token') !== token) return;
console.error('Error fetching user details:', err)    ;
if (err.response?.status === 401) handleLogout({ animate: false })      ;
}
}                                                     ;
fetchUserDetails()                         ;
return () => { active = false; };
}, [location.pathname, setUser, navigate, handleLogout]) ;
const brandingLogoUrl = user && branding.logoUrl
  ? `${process.env.REACT_APP_API_BASE_URL || ''}${branding.logoUrl}${branding.updatedAt ? `?v=${new Date(branding.updatedAt).getTime()}` : ''}`
  : '';
const logoSrc = isBranded ? brand.logoUrl : (brandingLogoUrl || '/logo_white.png');
const isCustomBrandingLogo = !isBranded && Boolean(brandingLogoUrl);
const isWideBrandLogo = isBranded && brand.logoAspect === 'wide';
const handleNavigation = (path, index) => {
if (typeof index === 'number') {
setSelectedTab(index)                      ;
}
navigate(path)                              ;
}                                           ;
const handleMenuOpen = (event) => {
setAnchorEl(event.currentTarget)    ;
}                                   ;
const handleMenuClose = () => {
setAnchorEl(null)                   ;
}                                   ;
const openCertificateUpdateDialog = () => {
setCertificateNumber(user.certificate_number || '');
setCertificateIssueDate(user.certificate_issue_date ? user.certificate_issue_date.substring(0, 10) : '');
setCertificateExpiryDate(user.certificate_expiry_date ? user.certificate_expiry_date.substring(0, 10) : '');
setCertError('');
setOpenCertificateDialog(true)                                                                               ;
}                                                                                                            ;
const handleOpenRegisterDialog = () => {
setOpenRegisterDialog(true);
}                                          ;
const submitCertificateUpdate = async () => {
try {
const token = localStorage.getItem('token');
await axios.put(
`${process.env.REACT_APP_API_BASE_URL}/api/users/update-certificate`,
{
certificate_number: certificateNumber || null,
certificate_issue_date: certificateIssueDate || null,
certificate_expiry_date: certificateExpiryDate || null,
},
{ headers: { Authorization: `Bearer ${token}` } }
)                                                                     ;
setUser((prevUser) => ({
...prevUser,
certificate_number: certificateNumber,
certificate_issue_date: certificateIssueDate,
certificate_expiry_date: certificateExpiryDate,
}))                                             ;
setOpenCertificateDialog(false)                                                       ;
} catch (error) {
console.error('Failed to update certificate details:', error)                         ;
setCertError(error.response?.data?.message || 'Error updating certificate details.');
}
}                                                                                     ;
const handleProfileMenuOpen = (event) => {
setProfileMenuEl(event.currentTarget)      ;
}                                          ;
const handleProfileMenuClose = () => {
setProfileMenuEl(null)                     ;
}                                          ;
const onFileSelected = (e) => {
const file = e.target.files[0]   ;
if (file) handleFileUpload(file) ;
}                                ;
const handleFileUpload = async (file) => {
const formData = new FormData()            ;
formData.append('profilePic', file)        ;
try {
const token = localStorage.getItem('token');
const res = await axios.post(
`${process.env.REACT_APP_API_BASE_URL}/users/upload-picture`,
formData,
{
headers: {
'Content-Type': 'multipart/form-data',
'Authorization': `Bearer ${token}`
},
}
)                                                             ;
console.log('Success:', res.data) ;
const profilePicUrl = res.data.profilePicUrl ;
if (profilePicUrl) {
const fullUrl = `${process.env.REACT_APP_API_BASE_URL}/${profilePicUrl}` ;
setUser((prevUser) => ({
...prevUser,
profilePicURL: fullUrl
}))                                                                      ;
}
} catch (error) {
console.error('Error uploading picture:', error)                         ;
}
}                                                                        ;
const handleChangePicture = () => {
if (fileInputRef.current) {
fileInputRef.current.click()        ;
}
}                                   ;
const handleResetPassword = () => {
setOldPassword('');
setNewPassword('');
setConfirmNewPassword('');
setPasswordError('');
setOpenResetDialog(true)   ;
}                          ;
const isValidPassword = (password) => {
const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+{};:,<.>]).{6,}$/;
return regex.test(password)                                                           ;
}                                                                                     ;
const handleSubmitResetPassword = async () => {
if (newPassword !== confirmNewPassword) {
setPasswordError("New passwords do not match.");
return                                                                                                    ;
}
if (!isValidPassword(newPassword)) {
setPasswordError(
"Password must be at least 6 characters and include uppercase, lowercase, number, and special character."
)                                                                                                         ;
return                                                                                                    ;
}
setPasswordError("");
try {
const token = localStorage.getItem('token');
const res = await axios.post(
`${process.env.REACT_APP_API_BASE_URL}/api/auth/change-password`,
{ oldPassword, newPassword },
{
headers: { Authorization: `Bearer ${token}` },
withCredentials: true,
}
)                                                                 ;
setOpenResetDialog(false);
setOldPassword('');
setNewPassword('');
setConfirmNewPassword('');
if (res.data?.reauthenticationRequired) {
clearRegisterSession();
setUser(null);
setDatabaseName('');
setRole('');
navigate('/login', {
replace: true,
state: { message: res.data.message || 'Password updated. Please sign in again.' },
});
}
} catch (error) {
setPasswordError(
error.response?.data?.message || "Failed to change password."
)                                                             ;
}
}                                                             ;
const menuItems = [
{
label: 'Dashboard',
path: '/dashboard',
roles: ['editor', 'admin', 'inspector', 'viewer'],
},
{
label: 'Admin Dashboard',
path: '/admin',
roles: ['admin'],
},
{
label: 'Equipment Register',
path: '/exregister',
roles: ['editor', 'admin', 'inspector', 'viewer'],
},
{
label: 'Import Data',
path: '/importdata',
roles: ['admin', 'inspector', 'editor'],
},
]                                        ;
const filteredMenuItems = menuItems.filter((item) =>
item.roles.includes(role)
)                                                    ;
const accountMenuItems = [
{
label: 'Change Picture',
onClick: handleChangePicture,
},
{
label: 'Update Certificate',
onClick: openCertificateUpdateDialog,
},
{
label: 'Change Register',
onClick: handleOpenRegisterDialog,
},
{
label: 'Change Password',
onClick: handleResetPassword,
},
{
label: 'Logout',
onClick: handleLogout,
},
]                                                    ;
const renderNavigationMenuItems = (closeMenu) =>
filteredMenuItems.map((item, index) => (
<MenuItem
key={item.path}
onClick={() => {
closeMenu()                                             ;
handleNavigation(item.path, index)                      ;
}}
>
{item.label}
</MenuItem>
))                                                     ;
const renderAccountMenuItems = (closeMenu) =>
accountMenuItems.map((item) => (
<MenuItem
key={item.label}
sx={item.label === 'Logout' ? { color: 'error.main', fontWeight: 700 } : undefined}
onClick={() => {
closeMenu()                                             ;
item.onClick()                                          ;
}}
>
{item.label}
</MenuItem>
))                                                     ;
useEffect(() => {
const currentTabIndex = filteredMenuItems.findIndex(
(item) => item.path === '/admin'
? location.pathname.startsWith('/admin')
: item.path === location.pathname
)                                                    ;
if (currentTabIndex !== -1) {
setSelectedTab(currentTabIndex)                      ;
}
}, [location, filteredMenuItems])                    ;
return (
<>
<AppBar
position="fixed"
elevation={0}
className="navbar"
sx={{
  background: 'linear-gradient(135deg, #0b0d12, #111622)',
  width: '100%',
  marginLeft: '0px',
  transition: 'width 0.3s ease-in-out, margin-left 0.3s ease-in-out',
  zIndex: (theme) => theme.zIndex.drawer + 1,
  borderBottom: '1px solid rgba(255,255,255,0.10)',
}}
>
<Toolbar
sx={{
  minHeight: { xs: '56px !important', sm: '64px !important' },
  px: { xs: 2, sm: 2.5 },
  gap: { xs: 1, lg: 2 },
}}
>
<Box
sx={{
flex: '0 1 auto',
display: 'flex',
alignItems: 'center',
minWidth: 0,
maxWidth: { xs: 'calc(100% - 48px)', sm: '58%', lg: 330, xl: 390 },
mr: { lg: 1 },
}}
>
<Box
  component="img"
  src={logoSrc}
  alt={isBranded ? brand.name : (isCustomBrandingLogo ? 'Register Logo' : 'EXreg Logo')}
  sx={{
    height: isBranded ? { xs: 36, sm: 42 } : (isCustomBrandingLogo ? { xs: '34px', sm: '40px' } : '25px'),
    width: isBranded ? (isWideBrandLogo ? { xs: 116, sm: 136 } : { xs: 36, sm: 42 }) : 'auto',
    maxWidth: isCustomBrandingLogo ? { xs: '180px', sm: '240px', md: '280px' } : '260px',
    objectFit: 'contain',
    objectPosition: 'left center',
    mr: { xs: 1, sm: 1.5 },
    flexShrink: 0,
    cursor: 'default',
    ...(isWideBrandLogo ? { backgroundColor: '#ffffff', p: '5px 7px', borderRadius: '3px' } : {}),
  }}
/>
{isBranded ? (
<Box className="navbar-register-identity" sx={{ minWidth: 0 }}>
  <Typography component="span" className="navbar-cobrand">Powered by EXREG</Typography>
  <Typography component="div" className="navbar-register-name" title={databaseName || undefined}>
    {databaseName || user?.database_name || 'Equipment register'}
  </Typography>
</Box>
) : (
<Typography
variant="h6"
sx={{
fontSize: { xs: '14px', sm: '18px', lg: '26px' },
fontWeight: 300,
whiteSpace: 'nowrap',
overflow: 'hidden',
textOverflow: 'ellipsis',
minWidth: 0,
}}
title={databaseName || undefined}
>
{user && databaseName ? `- ${databaseName}` : ''}
</Typography>
)}
</Box>
{user ? (
<>
<Box
sx={{
display: { xs: 'none', lg: 'flex' },
flex: '1 1 auto',
minWidth: 0,
justifyContent: 'flex-end',
alignItems: 'center',
fontWeight: 300,
}}
>
<Typography
variant="body1"
sx={{
display: { lg: 'none', xl: 'block' },
mr: 2,
maxWidth: 220,
overflow: 'hidden',
textOverflow: 'ellipsis',
whiteSpace: 'nowrap',
color: 'rgba(255,255,255,0.82)',
}}
>
{`${user.name} ${user.surname} (Role: ${role})`}
</Typography>
<Tabs
value={selectedTab}
textColor="inherit"
aria-label="Primary navigation"
sx={{
  mr: { lg: 1, xl: 2 },
  minWidth: 0,
  '.MuiTabs-indicator': {
    backgroundColor: isBranded ? brand.accent : '#d6d60a',
    height: 3,
    borderRadius: 3,
  },
  '.MuiTab-root': {
    textTransform: 'none',
    minWidth: 'auto',
    px: { lg: 1.25, xl: 2 },
    fontSize: { lg: 13, xl: 14 },
    fontWeight: 600,
    color: 'rgba(255,255,255,0.82)',
  },
  '.MuiTab-root.Mui-selected': {
    color: '#ffffff',
  },
}}
>
{filteredMenuItems.map((item, index) => (
<Tab
key={item.path}
label={item.label}
aria-current={
  (item.path === '/admin' ? location.pathname.startsWith('/admin') : location.pathname === item.path)
    ? 'page'
    : undefined
}
onClick={() => handleNavigation(item.path, index)}
/>
))}
</Tabs>
<Box
sx={{
display: 'flex',
alignItems: 'center',
gap: 1.25,
ml: { lg: 0.5, xl: 1 },
pl: { lg: 1, xl: 2 },
flexShrink: 0,
borderLeft: '1px solid rgba(255,255,255,0.12)',
}}
>
<Avatar
alt={`${user.name} ${user.surname}`}
src={user.profilePicURL || ''}
sx={{
width: 40,
height: 40,
border: '2px solid rgba(255,255,255,0.18)',
}}
>
{(!user.profilePicURL && user.name) ? user.name[0] : ''}
</Avatar>
<Button
onClick={handleProfileMenuOpen}
variant="outlined"
startIcon={<MenuIcon />}
aria-controls={profileMenuEl ? 'account-menu' : undefined}
aria-haspopup="true"
aria-expanded={profileMenuEl ? 'true' : undefined}
sx={{
textTransform: 'none',
fontWeight: 700,
borderRadius: 999,
borderColor: 'rgba(255,255,255,0.18)',
color: 'rgba(255,255,255,0.92)',
backgroundColor: 'transparent',
px: 1.8,
py: 0.7,
'&:hover': {
borderColor: 'rgba(255,255,255,0.32)',
backgroundColor: 'rgba(255,255,255,0.06)',
},
}}
>
Account
</Button>
</Box>
<Menu
id="account-menu"
anchorEl={profileMenuEl}
open={Boolean(profileMenuEl)}
onClose={handleProfileMenuClose}
>
{renderAccountMenuItems(handleProfileMenuClose)}
</Menu>
</Box>
<Box sx={{ display: { xs: 'none', sm: 'flex', lg: 'none' } }}>
<PopupState variant="popover" popupId="menu-popup">
{(popupState) => (
<>
<Button
  variant="contained"
  aria-label="Open navigation and account menu"
  {...bindTrigger(popupState)}
  sx={{
    textTransform: 'none',
    fontWeight: 700,
    borderRadius: 999,
    background: isBranded ? brand.primary : 'linear-gradient(135deg, #d6d60a, #ffd400)',
    color: isBranded ? '#fff' : '#111',
    boxShadow: isBranded ? `0 6px 18px ${alpha(brand.primary, 0.2)}` : '0 10px 20px rgba(214, 214, 10, 0.22)',
    '&:hover': { filter: 'brightness(0.98)' },
  }}
>
  Menu
</Button>
<Menu {...bindMenu(popupState)}>
{renderNavigationMenuItems(popupState.close)}
{renderAccountMenuItems(popupState.close)}
</Menu>
</>
)}
</PopupState>
</Box>
<Box sx={{ display: { xs: 'flex', sm: 'none' } }}>
<IconButton
size="large"
edge="end"
color="inherit"
onClick={handleMenuOpen}
aria-label="Open navigation and account menu"
aria-controls={anchorEl ? 'mobile-navigation-menu' : undefined}
aria-haspopup="true"
aria-expanded={anchorEl ? 'true' : undefined}
>
<MenuIcon />
</IconButton>
<Menu
id="mobile-navigation-menu"
anchorEl={anchorEl || undefined}
open={Boolean(anchorEl)}
onClose={handleMenuClose}
>
{renderNavigationMenuItems(handleMenuClose)}
{renderAccountMenuItems(handleMenuClose)}
</Menu>
</Box>
<input
type="file"
ref={fileInputRef}
style={{ display: 'none' }}
accept="image/*"
onChange={onFileSelected}
/>
</>
)
 : (
  <Box sx={{ display: 'flex', gap: 1 }}>
    <Button
      onClick={() => handleNavigation('/login')}
      sx={{
        textTransform: 'none',
        borderRadius: 999,
        border: '1px solid rgba(255,255,255,0.22)',
        color: 'rgba(255,255,255,0.92)',
        px: 2,
      }}
    >
      Login
    </Button>
    <Button
      onClick={() => handleNavigation('/register')}
      sx={{
        textTransform: 'none',
        fontWeight: 800,
        borderRadius: 999,
        background: 'linear-gradient(135deg, #d6d60a, #ffd400)',
        color: '#111',
        px: 2,
        boxShadow: '0 10px 20px rgba(214, 214, 10, 0.22)',
        '&:hover': { filter: 'brightness(0.98)' },
      }}
    >
      Register
    </Button>
  </Box>
)}
</Toolbar>
</AppBar>
{isLoggingOut && (
<div className="logout-transition" role="status" aria-live="polite">
<div className="logout-transition-panel">
<img src={logoSrc} alt={isBranded ? brand.name : (isCustomBrandingLogo ? 'Register logo' : 'EXREG')} className={`logout-transition-logo${isWideBrandLogo ? ' logout-transition-logo--wide' : ''}`} />
{isBranded && <Typography className="logout-transition-cobrand">Powered by EXREG</Typography>}
<div className="logout-transition-mark" aria-hidden="true">
<span />
</div>
<Typography className="logout-transition-title">Signing out</Typography>
<Typography className="logout-transition-copy">Securing your session</Typography>
<div className="logout-transition-progress" aria-hidden="true">
<span />
</div>
</div>
</div>
)}
<Dialog open={openCertificateDialog} onClose={() => setOpenCertificateDialog(false)}>
<DialogTitle>Update Certificate Details</DialogTitle>
<DialogContent>
<TextField
margin="dense"
label="Certificate Number"
type="text"
fullWidth
value={certificateNumber}
onChange={(e) => setCertificateNumber(e.target.value)}
/>
<TextField
margin="dense"
label="Issue Date"
type="date"
InputLabelProps={{ shrink: true }}
fullWidth
value={certificateIssueDate}
onChange={(e) => setCertificateIssueDate(e.target.value)}
/>
<TextField
margin="dense"
label="Expiry Date"
type="date"
InputLabelProps={{ shrink: true }}
fullWidth
value={certificateExpiryDate}
onChange={(e) => setCertificateExpiryDate(e.target.value)}
/>
{certError && (
<Typography variant="body2" color="error" sx={{ mt: 1 }}>
{certError}
</Typography>
)}
</DialogContent>
<DialogActions>
<Button onClick={() => setOpenCertificateDialog(false)}>Cancel</Button>
<Button variant="contained" onClick={submitCertificateUpdate}>
Save
</Button>
</DialogActions>
</Dialog>
<Dialog open={openResetDialog} onClose={() => setOpenResetDialog(false)}>
<DialogTitle>Reset Password</DialogTitle>
<DialogContent>
<TextField
autoFocus
margin="dense"
label="Old Password"
type="password"
fullWidth
value={oldPassword}
onChange={(e) => setOldPassword(e.target.value)}
/>
<TextField
margin="dense"
label="New Password"
type="password"
fullWidth
value={newPassword}
onChange={(e) => setNewPassword(e.target.value)}
helperText="At least 6 characters, with uppercase, lowercase, number, and special character."
/>
<TextField
margin="dense"
label="Confirm New Password"
type="password"
fullWidth
value={confirmNewPassword}
onChange={(e) => setConfirmNewPassword(e.target.value)}
/>
{passwordError && (
<Typography variant="body2" color="error" sx={{ mt: 1 }}>
{passwordError}
</Typography>
)}
</DialogContent>
<DialogActions>
<Button onClick={() => setOpenResetDialog(false)}>Cancel</Button>
<Button onClick={handleSubmitResetPassword} variant="contained">
Change Password
</Button>
</DialogActions>
</Dialog>
<RegisterPicker open={openRegisterDialog} onClose={() => setOpenRegisterDialog(false)} />
</>
)                                                                                             ;
}
export default Navbar ;
